import i18n from '@/i18n';

const WEEKDAYS = new Set(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']);

/** Describe common daily/weekly six-field crawler schedules. */
export function describeCron(expression: string | null): string {
  if (!expression) {
    return i18n.t('admin:cron.unset');
  }
  const parts = expression.trim().split(/\s+/);
  if (parts.length !== 6) {
    return expression;
  }
  const [second, minute, hour, day, month, weekday] = parts;
  const plainNumber = /^\d{1,2}$/;
  if (
    second !== '0' ||
    !plainNumber.test(minute) ||
    !plainNumber.test(hour) ||
    day !== '*' ||
    month !== '*'
  ) {
    return expression;
  }
  const time = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
  if (weekday === '*') {
    return i18n.t('admin:cron.daily', { time });
  }
  const days = weekday.split(',').map((name) => name.toLowerCase());
  if (days.some((name) => !WEEKDAYS.has(name))) {
    return expression;
  }
  return i18n.t('admin:cron.weekly', {
    days: days.map((name) => i18n.t(`admin:cron.${name}`)).join(i18n.t('admin:cron.separator')),
    time,
  });
}
